import { Component, output } from '@angular/core';
import { IpoLanguageService } from '@ip-only/front-end-library';
import { DuctService } from '../../service/map/duct/duct.service';
import { SpanService } from '../../service/map/span/span.service';
import { DuctMapping } from '../../span-progress-entities';
import { ductInformationColumns } from './duct-information-columns';
import {
  DuctInteractionService,
  SelectedDuctInformation,
} from './services/duct-interaction.service';

@Component({
  selector: 'app-duct-table',
  templateUrl: './duct-table.component.html',
  styleUrls: ['./duct-table.component.scss'],
  standalone: false,
})
export class DuctTableComponent {
  language$ = this.languageService.getLanguage$();
  ductData$ = this.ductService.getDuctList$();
  columns = ductInformationColumns;
  activePage = 0;
  loadingState$ = this.ductService.getEntityLoadingState$();
  selectedDuct$ = this.ductInteractionService.getSelectedDuct$();
  searchValue$ = this.ductInteractionService.getSearchValue$();
  ductSideMenuOpen = false;

  closeSidePanel = output<void>();

  constructor(
    private ductService: DuctService,
    private ductInteractionService: DuctInteractionService,
    private languageService: IpoLanguageService,
    private spanService: SpanService,
  ) {}

  handleSearch(searchValue: string) {
    this.ductInteractionService.setSearchValue(searchValue);
  }

  onPageChange(clickedPage: number) {
    this.activePage = clickedPage;
  }

  onRowClicked(duct: DuctMapping) {
    const selectedDuct =
      this.ductInteractionService.getSelectedDuctValue().duct;
    if (selectedDuct?.id === duct.id) {
      this.ductInteractionService.setSelectedDuct({
        duct: null,
        interaction: 'ductListInteraction',
      });
    } else {
      this.ductInteractionService.setSelectedDuct({
        duct: duct,
        interaction: 'ductListInteraction',
      });
    }
  }
  markSelectedRow(selectedDuct: SelectedDuctInformation) {
    return (duct: DuctMapping) => {
      if (selectedDuct.duct?.id === duct.id) {
        return { background: '#cdfcfc' };
      }
      return null;
    };
  }

  findSpanIdFromSerialNumber(searchString: string | null) {
    return this.spanService
      .getSpanDataValue()
      .find((span) => span.properties.serialNumber === searchString)?.properties
      .spanId;
  }

  onDuctMenuClicked(e: MouseEvent | Event): void {
    e.stopPropagation();
    this.closeSidePanel.emit();
  }
}
